/** True when Gatsby location is the site index (handles trailing slash). */
export function isHomePathname(pathname) {
  if (!pathname) {
    return false;
  }
  const normalized = pathname.replace(/\/$/, "") || "/";
  return normalized === "/";
}
